module.exports = __webpack_public_path__ + "img/furniture.db0d658.jpeg";